module.exports = __webpack_public_path__ + "img/046-micronesia.050984fa.svg";